import { CheckIcon } from 'lucide-react';
import { QuestionOption } from '../types/form';
import { OtherField } from './OtherField';
interface ImageOptionCardProps {
  option: QuestionOption;
  shortcut: string;
  selected: boolean;
  featured: boolean;
  multi: boolean;
  otherText: string;
  onSelect: () => void;
  onOtherChange: (value: string) => void;
}
export function ImageOptionCard({
  option,
  shortcut,
  selected,
  featured,
  multi,
  otherText,
  onSelect,
  onOtherChange
}: ImageOptionCardProps) {
  return <button type="button" role={multi ? 'checkbox' : 'radio'} aria-checked={selected} onClick={onSelect} className={`group flex h-full flex-col overflow-hidden rounded-sm border text-left transition-colors duration-200 ease-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400 focus-visible:ring-offset-2 focus-visible:ring-offset-olive-800 ${selected ? 'border-cream-100 bg-olive-600' : 'border-cream-100/15 bg-olive-700/60 hover:border-cream-100/40'}`} data-id="element-28" data-mp="khsm5rqksx4h">
      <div className={`relative w-full overflow-hidden ${featured ? 'aspect-[16/10]' : 'aspect-[4/3]'}`} data-id="element-29" data-mp="3fibsmbh3gqfb">
        <img src={option.image} alt="" className={`h-full w-full object-cover transition-transform duration-300 ease-soft group-hover:scale-[1.03] ${selected ? 'opacity-100' : 'opacity-85'}`} data-id="element-30" data-mp="3jjnjekbpfhp3" />
        <span className={`absolute left-3 top-3 flex h-7 w-7 items-center justify-center rounded-full font-sans text-[11px] transition-colors duration-200 ease-soft ${selected ? 'bg-cream-100 text-olive-800' : 'bg-olive-900/70 text-cream-100'}`} aria-hidden="true" data-id="element-31" data-mp="28xkqnfodj81">
          {selected ? <CheckIcon className="h-3.5 w-3.5" strokeWidth={2.5} data-id="element-32" data-mp="g381ahhiq730" /> : shortcut}
        </span>
      </div>

      <div className="mt-auto flex min-h-[84px] flex-col justify-center gap-1 px-4 py-4" data-id="element-33" data-mp="ky3xlttsfglx">
        <span className="font-display text-xl leading-snug text-cream-50" data-id="element-34" data-mp="pzjk7qbm5v6f">{option.label}</span>
        {option.detail && !selected && <span className="font-sans text-xs text-cream-100/55" data-id="element-35" data-mp="3rhp4ymqnvbix">{option.detail}</span>}
        {option.isOther && selected && <div className="pt-1" data-id="element-36" data-mp="a1qv31nz126p">
            <OtherField value={otherText} placeholder="Digite aqui" onChange={onOtherChange} data-id="element-37" data-mp="a2s83bojryr2" />
          </div>}
      </div>
    </button>;
}